import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserReport } from '../Dto/userReport';
import { Jetons } from '../Dto/jetons';
import { User } from '../Dto/user';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  saveUserReport(user: User): Observable<any> {
    return this.http
      .post('/api/User/UserReportSave', user, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'text'
      })
      .pipe((data) => data);
  }

  delete(idUser: string): Observable<any> {
    return this.http
      .delete('/api/User/Delete/' + idUser, { responseType: 'text' })
      .pipe((val) => val);
  }

  getAllUserReport(filter: object): Observable<UserReport[]> {
    return this.http
      .post('/api/User/GetAllUserReport', filter, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      })
      .pipe(
        map((jsonArray: UserReport[]) =>
          jsonArray.map((jsonItem) => UserReport.fromJson(jsonItem))
        )
      );
  }

  setToken(post: object): Observable<object> {
    return this.http.post('/api/User/SetToken', post).pipe((val) => val);
  }

  setByPass(idUser: string): Observable<object> {
    return this.http.get('/api/User/Bypass/' + idUser).pipe((val) => val);
  }


  getUserJetons(idUser: string): Observable<Jetons[]> {
    let params = new HttpParams();
    params = params.append('idUser', idUser);
    return this.http
      .get('/api/User/GetUserJetons', { params: params })
      .pipe(
        map((jsonArray: Jetons[]) =>
          jsonArray.map((jsonItem) => Jetons.fromJson(jsonItem))
        )
      );
  }

  overrideReport(idUser: string): Observable<object> {
    let params = new HttpParams();
    params = params.append('idUser', idUser);
    return this.http
      .get('/api/User/OverrideReport', { params: params })
      .pipe((val) => val);
  }

  setLanguage(lang: string): Observable<object> {
    let params = new HttpParams();
    params = params.append('culture', lang);
    return this.http
      .get('/api/User/SetLanguage', { params: params })
      .pipe((val) => val);
  }

  promoteBeta(idUser: string): Observable<any> {
    return this.http
      .put('/api/User/PromoteBeta', { id: idUser })
      .pipe(map((data) => +data));
  }

  getListUserOptions(): Observable<any[]> {
    return this.http.get<any[]>('/api/User/ListUserOptions')
  }

  changePassword(password: string): Observable<object> {
    return this.http.post('/api/User/ChangePassword', { newPassword: password });
  }

  resetPassword(password: string, emailUser: string, uid: string): Observable<object> {
    return this.http.post('/api/User/ResetPassword', { newPassword: password, email: emailUser, uid: uid });
  }

  validateUID(email: string, uid: string): Observable<object> {
    let params = new HttpParams();
    params = params.append('email', email);
    params = params.append('uid', uid);
    return this.http.get('/api/User/CheckUid', { params: params }).pipe(data => data);
  }


  recoverPassword(email: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('email', email);
    return this.http.get('/api/User/RecoverPassword', { params: params, responseType: 'text' }).pipe(data => data);
  }

}
